function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/* eslint-disable jsx-a11y/label-has-for */
import React, { isValidElement, cloneElement } from 'react';
import PropTypes from 'prop-types';
import AbstractInput from '../AbstractInput';
import AlignToText from '../AlignToText';
import classNames from '../utils/classNames';
import forwardRef from '../utils/forwardRef';
/**
 * The TextInputBox component provides a single line text input form element
 *
 * - [MDN docs for input[type="text"]](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/text)
 *
 * ## Related Components
 *
 * - [TextArea](../TextArea/README.md)
 * - [Label](../Label/README.md)
 *
 * ## Usage
 *
 * ```jsx
 * <TextInputBox
 *   label="Date of Birth"
 *   placeholder="MM/DD/YYYY"
 *   accessoryCta={(
 *    <Button
 *      variant="quick-action"
 *    >
 *      <Icon type="favorite" />
 *    </Button>
 *   )}
 *   supportiveText="Example: 10/24/1983"
 * />
 *```
 */

var TextInputBox = /*#__PURE__*/function (_AbstractInput) {
  _inherits(TextInputBox, _AbstractInput);

  var _super = _createSuper(TextInputBox);

  function TextInputBox() {
    _classCallCheck(this, TextInputBox);

    return _super.apply(this, arguments);
  }

  _createClass(TextInputBox, [{
    key: "render",
    value: function render() {
      var _accessoryCta$props;

      var _this$props = this.props,
          qa = _this$props.qa,
          id = _this$props.id,
          node = _this$props.node,
          className = _this$props.className,
          type = _this$props.type,
          placeholder = _this$props.placeholder,
          variant = _this$props.variant,
          disabled = _this$props.disabled,
          readOnly = _this$props.readOnly,
          value = _this$props.value,
          onChange = _this$props.onChange,
          accessoryCta = _this$props.accessoryCta,
          label = _this$props.label,
          supportiveText = _this$props.supportiveText,
          supportiveTextType = _this$props.supportiveTextType,
          autoComplete = _this$props.autoComplete,
          minLength = _this$props.minLength,
          maxLength = _this$props.maxLength,
          inputMode = _this$props.inputMode,
          form = _this$props.form,
          pattern = _this$props.pattern;
      var isFocused = this.state.isFocused;
      var isActivated = (value || '').trim() !== '';

      var _TextInputBox$getClas = TextInputBox.getClassName({
        className: className,
        variant: variant,
        isActivated: isActivated,
        isFocused: isFocused,
        disabled: disabled,
        supportiveTextType: supportiveTextType
      }),
          root = _TextInputBox$getClas.root,
          textInputRootClass = _TextInputBox$getClas.textInputRoot,
          textInputClass = _TextInputBox$getClas.textInput,
          labelClass = _TextInputBox$getClas.label,
          accessoryCtaSpacerClass = _TextInputBox$getClas.accessoryCtaSpacer,
          supportiveTextClass = _TextInputBox$getClas.supportiveText;

      var inputId = id || this.id;
      return /*#__PURE__*/React.createElement("div", {
        qa: qa,
        className: root
      }, label && /*#__PURE__*/React.createElement("label", {
        "data-qa": "".concat(qa, "#label"),
        htmlFor: inputId,
        className: labelClass
      }, label), /*#__PURE__*/React.createElement("div", {
        className: textInputRootClass
      }, /*#__PURE__*/React.createElement("input", {
        readOnly: readOnly,
        "data-qa": "".concat(qa, "#input"),
        ref: node,
        className: textInputClass,
        id: inputId,
        type: type,
        value: value,
        disabled: disabled,
        placeholder: placeholder,
        onChange: onChange,
        minLength: minLength,
        maxLength: maxLength,
        autoComplete: autoComplete,
        inputMode: inputMode,
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        form: form,
        pattern: pattern
      }), accessoryCta && /*#__PURE__*/React.createElement(AlignToText, {
        fontStyle: "body",
        spacer: /*#__PURE__*/React.createElement("div", {
          className: accessoryCtaSpacerClass
        }, accessoryCta === null || accessoryCta === void 0 ? void 0 : (_accessoryCta$props = accessoryCta.props) === null || _accessoryCta$props === void 0 ? void 0 : _accessoryCta$props.children)
      }, /*#__PURE__*/isValidElement(accessoryCta) ? /*#__PURE__*/cloneElement(accessoryCta, {
        qa: "".concat(qa, "#accessoryCta"),
        disabled: disabled
      }) : accessoryCta)), supportiveText && /*#__PURE__*/React.createElement("div", {
        "data-qa": "".concat(qa, "#supportiveText"),
        className: supportiveTextClass
      }, supportiveText));
    }
  }]);

  return TextInputBox;
}(AbstractInput);

TextInputBox.defaultProps = {
  qa: '',
  className: '',
  id: null,
  // html5 attributes
  type: 'text',
  placeholder: '',
  disabled: false,
  name: null,
  value: '',
  autoComplete: null,
  form: null,
  onChange: function onChange() {},
  onFocus: function onFocus() {},
  onBlur: function onBlur() {},
  // design attributes
  variant: 'single',
  accessoryCta: null,
  supportiveText: null,
  supportiveTextType: 'regular'
};
TextInputBox.propTypes = {
  /**
   * Unique id for QA test automation
   */
  qa: PropTypes.string,

  /**
   * The id tying the labels to the input control. If not provided
   * one will be created
   */
  id: PropTypes.string,

  /**
   * Allows adding a custom class or series of classes on the component
   * useful for setting margin or padding
   */
  className: PropTypes.string,

  /**
   * The name associated with the typed in value
   */
  name: PropTypes.string,

  /**
   * The Typed in text
   */
  value: PropTypes.string,

  /**
   * Type of text input
   */
  type: PropTypes.oneOf(['text', 'password', 'url', 'search', 'email']),

  /**
   * The placeholder text to show when no text has been inputted
   */
  placeholder: PropTypes.string,

  /**
   * Whether or not the user is able to use the control
   * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#attr-disabled
   */
  disabled: PropTypes.bool,

  /**
   * The id of the form element the text input is associated with
   * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#attr-form
   */
  form: PropTypes.string,

  /**
   * hint to browsers for displaying type of virtual keyboard
   * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#attr-inputmode
   */
  inputMode: PropTypes.oneOf(['none', 'text', 'tel', 'url', 'email', 'numeric', 'decimal', 'search']),

  /**
   * - [MDN attribute doc](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#attr-autocomplete)
   * - [Autocomplete valid values](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete#values)
   */
  autoComplete: PropTypes.string,

  /**
   * The minimum number of characters that can be typed
   * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#attr-minlength
   */
  minLength: PropTypes.number,

  /**
   * The maximum number of characters that can be typed
   * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#attr-maxlength
   */
  maxLength: PropTypes.number,

  /**
   * Regular expression the value must match
   * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#attr-pattern
   */
  pattern: PropTypes.string,

  /**
   * The presentational variant of the text input box.
   */
  variant: PropTypes.oneOf(['single']),

  /**
   * cta to display inline with the text input
   */
  accessoryCta: PropTypes.node,

  /**
   * Additional text to help provide additional help or context to the input
   */
  supportiveText: PropTypes.node,

  /**
   * Affects the presentation of the supportive text
   */
  supportiveTextType: PropTypes.oneOf(['regular', 'success', 'error', 'legal']),

  /**
   * event callback to be called when text control is focused
   */
  onFocus: PropTypes.func,

  /**
  * event callback to be called when text control is blurred / loses focus
  */
  onBlur: PropTypes.func,

  /**
  * event callback to be called when text is entered or removed from the control
  */
  onChange: PropTypes.func
};

TextInputBox.getClassName = function (_ref) {
  var isActivated = _ref.isActivated,
      isFocused = _ref.isFocused,
      disabled = _ref.disabled,
      readOnly = _ref.readOnly,
      className = _ref.className,
      supportiveTextType = _ref.supportiveTextType;
  return {
    root: classNames(className, disabled && 'psw-c-t-disabled'),
    label: classNames('psw-l-line-left', 'psw-t-title-s', 'psw-m-b-5'),
    textInputRoot: classNames({
      'psw-is-active': isActivated
    }, {
      'psw-is-disabled': disabled
    }, {
      'psw-is-focused': isFocused
    }, 'psw-l-line-repel', 'psw-p-y-4', 'psw-p-l-5', 'psw-p-r-3', 'psw-r-pill', 'psw-b-0', 'psw-ally-indicator', 'psw-ally-indicator-gap-1', 'psw-c-bg-form-field', 'psw-c-bg-interactive-1', 'psw-m-sub-x-5'),
    textInput: classNames('psw-t-body', 'psw-m-r-3', 'psw-c-bg-0', 'psw-fill-x'),
    accessoryCtaSpacer: classNames('psw-m-x-5', 'psw-l-line-left'),
    supportiveText: classNames('psw-m-t-2', supportiveTextType !== 'legal' ? 'psw-t-subtitle' : 'psw-t-utility', !disabled && supportiveTextType === 'success' && 'psw-c-t-success', !disabled && supportiveTextType === 'error' && 'psw-c-t-error', !disabled && supportiveTextType === 'legal' && 'psw-c-t-2')
  };
};

export default forwardRef({
  name: 'TextInputBox',
  ClassComponent: TextInputBox
});